import pixels from "@/pixels/index.js";
import Vue from "vue";
import bus from "@/bus";

describe("pixels/index.js", () => {
  beforeEach(() => {
    jest.spyOn(pixels, "initProvider");
    jest.spyOn(pixels, "install");
  });

  const provider = {
    queue: [jest.fn()]
  };

  it("PixelesMotor", () => {
    expect(pixels.initProvider("", provider, Vue)).not.toBeNull();
  });

  it("pixels.initProvider", () => {
    pixels.initProvider("", provider, Vue);
    const initProviderMock = jest.spyOn(pixels, "initProvider");
    expect(initProviderMock).toHaveBeenCalled();
  });

  it("pixels.install", () => {
    pixels.install(Vue);
    bus.$emit("mutation", {
      mutation: {
        type: "ON_ROUTE",
        payload: { name: "consulta" }
      }
    });
    const installMock = jest.spyOn(pixels, "install");
    expect(installMock).toHaveBeenCalled();
  });

  it("pixels.install type != on_route", () => {
    pixels.install(Vue);
    bus.$emit("mutation", {
      mutation: {
        type: "ADOBE_APP_STARTED",
        payload: { name: "consulta" }
      }
    });
    const installMock = jest.spyOn(pixels, "install");
    expect(installMock).toHaveBeenCalled();
  });

  it("pixel.install analytics:event", () => {
    pixels.install(Vue);
    bus.$emit("analytics:event", {
      event: "route_change",
      eventData: {
        to: { name: "consulta" },
        from: { name: "consulta" }
      }
    });
    const installMock = jest.spyOn(pixels, "install");
    expect(installMock).toHaveBeenCalled();
  });

  it("pixel.install  analytics:event != route_change", () => {
    pixels.install(Vue);
    bus.$emit("analytics:event", {
      event: "test_event",
      eventData: {
        to: { name: "consulta" },
        from: { name: "consulta" }
      }
    });
    const installMock = jest.spyOn(pixels, "install");
    expect(installMock).toHaveBeenCalled();
  });
});
